import { render, staticRenderFns } from "./Lesson7.vue?vue&type=template&id=3bc2ba0a&scoped=true&"
import script from "./Lesson7.vue?vue&type=script&lang=js&"
export * from "./Lesson7.vue?vue&type=script&lang=js&"
import style0 from "./Lesson7.vue?vue&type=style&index=0&id=3bc2ba0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc2ba0a",
  null
  
)

export default component.exports